// extracted by mini-css-extract-plugin
export default {"discount":"HF4rs","additionally":"hXMk1"};